import React from "react";
import Icon from "@mdi/react";
import { mdiMapMarker } from "@mdi/js";
import { Marker } from "react-map-gl";
import useHttpMaps from "../../hooks/useHttpMaps";
import SpinnerHandler from "../../hoc/SpinnerHandler/SpinnerHandler";
import "./Map.scss";

const Markers = (props) => {
  const { data, isLoading } = useHttpMaps(props);
  const { handleSelectMarker, color } = props;

  return (
    <SpinnerHandler isLoading={isLoading}>
      {data.map(
        (item) =>
          item.lat &&
          item.lng && (
            <Marker key={item.id} latitude={item.lat} longitude={item.lng}>
              <button
                className="markerButton"
                onClick={() => handleSelectMarker(item)}
              >
                <Icon
                  path={mdiMapMarker}
                  size={1}
                  horizontal
                  vertical
                  rotate={180}
                  color={color}
                />
              </button>
            </Marker>
          )
      )}
    </SpinnerHandler>
  );
};

export default Markers;
